import Icon from './Icon';
import { toggleTheme, useTheme } from '@/lib/theme';

// Light/dark flip — one round icon button, shared by every shell (AppShell,
// TripShell, map mode settings). Shows the theme you'd switch TO.
export default function ThemeToggle({ size = 32 }: { size?: number }) {
  const dark = useTheme() === 'dark';
  return (
    <button
      onClick={toggleTheme}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
      className="wa-focusable"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        border: '1px solid var(--line)',
        background: 'transparent',
        color: 'var(--ink-soft, #5c5046)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        flexShrink: 0,
      }}
    >
      <Icon name={dark ? 'sun' : 'moon'} size={15} />
    </button>
  );
}
